import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import {
  type Field,
  Text,
  TextWithTooltip,
  type User,
} from '@pbt/pbt-ui-components'

import UserSelect, {
  UserSelectFilterScope,
} from '~/components/common/inputs/UserSelect'
import { TeamFilter } from '~/types'

export interface AppointmentDropOffSettingsProps {
  businessId: string
  defaultPickUpHandlerId: Field
  preloadUser?: Partial<User>
}

export const AppointmentDropOffSettings = ({
  businessId,
  defaultPickUpHandlerId,
  preloadUser,
}: AppointmentDropOffSettingsProps) => {
  const { t } = useTranslation('Businesses')
  return (
    <Box sx={{ mt: 2, maxWidth: '23rem' }}>
      <Text strong sx={{ mb: 1 }} variant="subheading3">
        {t('Businesses:APPOINTMENT_CONFIGURATION.DROP_OFF_SETTINGS')}
      </Text>
      <TextWithTooltip
        sx={{ mb: 0.5 }}
        tooltipText={t(
          'Businesses:APPOINTMENT_CONFIGURATION.ASSIGN_A_TEAM_FOR_PICK_UPS_TOOLTIP',
        )}
        variant="body2"
      >
        {t('Businesses:APPOINTMENT_CONFIGURATION.ASSIGN_A_TEAM_FOR_PICK_UPS')}
      </TextWithTooltip>
      <UserSelect
        preload
        businessId={businessId}
        field={defaultPickUpHandlerId}
        filterScope={UserSelectFilterScope.TechsAndAssistants}
        label={t('Businesses:APPOINTMENT_CONFIGURATION.TEAM_SELECT_LABEL')}
        preloadUser={preloadUser as User}
        teamFilter={TeamFilter.TEAM}
      />
    </Box>
  )
}
